module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.shouldRenderComponent) ? _c('div', {
    staticClass: "user-quota marg-1-bottom text-dark",
    class: {
      'user-quota--sidebar': _vm.isSidebar
    }
  }, [_c('div', {
    staticClass: "user-quota__body"
  }, [_c('table', {
    staticClass: "d-table user-quota__table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('div', {
    staticClass: "user-quota__table-header"
  }, [_c('div', {
    staticClass: "user-quota__title-group"
  }, [_c('h4', {
    staticClass: "user-quota__title"
  }, [_vm._v(_vm._s(_vm.i18n.userQuota))]), _vm._v(" "), (_vm.employments.length > 0) ? _c('div', {
    staticClass: "user-quota__employment"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedEmploymentId),
      expression: "selectedEmploymentId"
    }],
    staticClass: "do-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedEmploymentId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.employments), function(employment) {
    return _c('option', {
      key: employment.id,
      domProps: {
        "value": employment.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(employment.title) + " - " + _vm._s(employment.employment_number || employment.id) + "\n\t\t\t\t\t\t")])
  }), 0)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "user-quota__subtitle"
  }, [_vm._v("Saldo i KMD pr. " + _vm._s(_vm.quotaDateLabel))])])]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.i18n.balance) + "\n\t\t\t")]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.i18n.used))]), _vm._v(" "), _c('th', {
    staticClass: "is-number"
  }, [_vm._v(_vm._s(_vm.i18n.difference))])])]), _vm._v(" "), _c('tbody', [(_vm.isLoadingEmployments || _vm.isLoadingQuotas) ? _c('tr', [_vm._m(0)]) : (_vm.errorMessage) ? _c('tr', [_c('td', {
    staticClass: "user-quota__status-cell",
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "user-quota__error"
  }, [_vm._v("\n              " + _vm._s(_vm.errorMessage) + "\n            ")])])]) : (_vm.hasLoadedQuotas && _vm.sortedQuotas.length === 0) ? _c('tr', [_c('td', {
    staticClass: "user-quota__status-cell",
    attrs: {
      "colspan": "4"
    }
  }, [_c('p', {
    staticClass: "user-quota__empty"
  }, [_vm._v("\n              " + _vm._s(_vm.i18n.noQuotas) + "\n            ")])])]) : _vm._l((_vm.sortedQuotas), function(quota) {
    return _c('tr', {
      key: quota.QuotaNumber
    }, [_c('td', [_c('div', {
      staticClass: "user-quota__quota-title"
    }, [_vm._v(_vm._s(quota.QuotaTypaText || quota.QuotaType))]), _vm._v(" "), _c('div', {
      staticClass: "user-quota__quota-meta"
    }, [_vm._v("\n              " + _vm._s(_vm.i18n.deductionPeriod) + ": " + _vm._s(_vm.formatDateRange(quota.DeductionStartDate, quota.DeductionEndDate)) + "\n            ")])]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(quota.QuotaAccrued)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(quota.QuotaUsed)))]), _vm._v(" "), _c('td', {
      staticClass: "is-number"
    }, [_vm._v(_vm._s(_vm.formatDecimal(quota.QuotaValue)))])])
  })], 2)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "user-quota__status-cell",
    attrs: {
      "colspan": "4"
    }
  }, [_c('div', {
    staticClass: "user-quota__loading"
  }, [_c('div', {
    staticClass: "do-spinner"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c8ebac1c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/KMD/UserQuota.vue
// module id = 2124
// module chunks = 1